<template>
  <el-dialog
    title="设置分享内容"
    width="600px"
    top="calc( 50vh - 250px )"
    custom-class="group-share"
    center
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :append-to-body="true"
    :handleCancel="handleCancel"
  >
    <el-scrollbar class="share-content">
      <div class="paper-list-content">
        <el-table :data="contentList" style="width: 100%" :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
          <el-table-column prop="name" label="报纸名称" min-width="100"></el-table-column>
          <el-table-column prop="show" label="是否展示" min-width="200">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.show">
                <el-radio class="theme-radio" :label="1">展示</el-radio>
                <el-radio class="theme-radio" :label="0">不展示</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="展示顺序">
            <template slot-scope="scope">
              <div class="button-group">
                <div class="item-info-icon info-icon-up">
                  <img src="@imgs/bookshelfedit/MoveTop@2x.png" title="置顶" @click="clickTopUp(scope.row)" alt="" />
                </div>
                <div class="item-info-icon info-icon-up">
                  <img src="@imgs/bookshelfedit/icon_up.png" title="上移" @click="clickUp(scope.row.id)" alt="" />
                </div>
                <div class="item-info-icon info-icon-down">
                  <img src="@imgs/bookshelfedit/icon_down.png" title="下移" @click="clickDown(scope.row.id)" alt="" />
                </div>
                <div class="item-info-icon info-icon-up">
                  <img src="@imgs/bookshelfedit/MoveBottom@2x.png" title="置底" @click="clickBottomDown(scope.row)" alt="" />
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-scrollbar>
    <div class="default-edit-footer">
      <div class="edit-footer-item left" @click="saveThen()">保存</div>
      <div class="edit-footer-item right" @click="handleCancel()">取消</div>
    </div>
  </el-dialog>
</template>

<script>
import compareVipRight from '@components/common/compareVipRight.js'
import paperApi from '@api/paperManager'
import { isLogin } from '@/utils'

export default {
  name: 'defaultEdit',
  mixins: [compareVipRight],
  data() {
    return {
      dialogVisible: false,
      total: 0,
      contentList: [],
      submitList: []
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.initContent()
      }
    }
  },
  components: {},
  computed: {
    bookObj() {
      return this.$store.state.config.bookObj
    },
    userName() {
      return localStorage.getItem('username')
    },
    booksCurrentSubAccount() {
      return this.$store.state.manage.booksCurrentSubAccount
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    setHeaderCellStyle(options) {
      return { 'background-color': '#fafafa', color: '#333', 'text-align': 'center', 'border-left': 'none', 'border-right': 'none' }
    },
    setCellStyle(options) {
      return { 'text-align': 'center', border: 'none' }
    },
    initContent() {
      paperApi.getShareContent({ userName: this.booksCurrentSubAccount || this.userName }).then((res) => {
        if (res.status && res.data && res.data.status === 0) {
          console.log(res.data)
          this.contentList = res.data.data
        }
      })
    },
    clickTopUp(currentItem) {
      let filterIndex
      let id = currentItem.id
      this.contentList.some((item, itemIndex) => {
        if (item.id === id) {
          filterIndex = itemIndex
          return true
        }
      })
      if (filterIndex === 0) {
        this.$message({
          type: 'error',
          message: '第一条数据已置顶'
        })
      } else {
        let leftList = []
        this.contentList.forEach((item) => {
          if (item.id !== id) {
            leftList.push(item)
          }
        })
        leftList.unshift(currentItem)
        this.contentList = leftList
      }
    },
    clickBottomDown(id) {
      let filterIndex
      this.contentList.some((item, itemIndex) => {
        if (item.id === id) {
          filterIndex = itemIndex
          return true
        }
      })
      if (filterIndex === this.contentList.length - 1) {
        this.$message({
          type: 'error',
          message: '最后一条数据已置底'
        })
      } else {
        let currentId = id
        let leftList = []
        this.contentList.forEach((item, i) => {
          if (item !== currentId) {
            leftList.push(item)
          }
        })
        leftList.push(currentId)
        this.contentList = leftList
      }
    },
    clickUp(id) {
      let filterIndex
      let currentItem
      this.contentList.some((item, itemIndex) => {
        if (item.id === id) {
          filterIndex = itemIndex
          currentItem = item
          return true
        }
      })
      if (filterIndex === 0) {
        this.$message({
          type: 'error',
          message: '第一条数据, 不能上移'
        })
      } else {
        let prev = this.contentList[filterIndex - 1]
        let prevIndex = filterIndex - 1
        // 交换两条数剧的位置
        this.$set(this.contentList, prevIndex, currentItem)
        this.$set(this.contentList, filterIndex, prev)
      }
    },
    clickDown(id) {
      let filterIndex
      let currentItem
      this.contentList.some((item, itemIndex) => {
        if (item.id === id) {
          filterIndex = itemIndex
          currentItem = item
          return true
        }
      })
      if (filterIndex === this.contentList.length - 1) {
        this.$message({
          type: 'error',
          message: '最后一条数据, 不能下移'
        })
      } else {
        let next = this.contentList[filterIndex + 1]
        let nextIndex = filterIndex + 1
        this.$set(this.contentList, nextIndex, currentItem)
        this.$set(this.contentList, filterIndex, next)
      }
    },
    saveThen() {
      isLogin()
      let shareContent = []
      this.contentList.forEach((item) => {
        shareContent.push({ id: item.id, show: item.show })
      })
      const params = {
        userName: this.booksCurrentSubAccount || this.userName,
        shareContent: JSON.stringify(shareContent)
      }
      paperApi.setShareContent(params).then((res) => {
        if (res && res.data && res.data.status === 0) {
          this.dialogVisible = false
          this.$alert('保存成功', '提示', {
            confirmButtonText: '确定'
          })
        } else {
          this.$alert('保存失败', '提示', {
            confirmButtonText: '确定'
          })
        }
      })
    }
  },
  created() {},
  destroyed() {}
}
</script>
<style lang="scss" scoped>
.share-content {
  width: 100%;
  height: 353px;
  overflow-x: hidden;
  .paper-list-content {
    width: 100%;
    height: 100%;
    .button-group {
      display: flex;
      .item-info-icon {
        width: 18px;
        height: 18px;
        margin-left: 10px;
        cursor: pointer;
        &.info-icon-up {
          margin-left: 5px;
        }
        &.info-icon-down {
          margin-left: 3px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.default-edit-footer {
  width: 550px;
  height: 50px;
  line-height: 36px;
  font-size: 14px;
  padding-top: 10px;
  background-color: #ffffff;
  text-align: center;
  position: absolute;
  bottom: 0;
  z-index: 99;

  .edit-footer-item {
    cursor: pointer;
    display: inline-block;
    height: 36px;
    border: 1px solid #df5813;
    text-align: center;
    width: 100px;
    &.left {
      background-color: #df5813;
      color: #fff;
    }
    &.right {
      margin-left: 30px;
    }
  }
}
</style>
<style lang="scss">
.group-share {
  height: 450px;
}
</style>
